import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from '../redux/authReducer';
import { uiReducer } from '../redux/uiReducer';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer
  }
})